import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import { ImageMarker } from '@schamburg-web/lakecounty';
import React from 'react';
import MessageSignCard from './MessageSignCard';

export const messageSignIcon = '/mapicons/message-cropped.svg';

const ImageDmsMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  return (
    <ImageMarker
      src={messageSignIcon}
      name={module.moduleLabel}
      showOutline={false}
    />
  );
};

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 50,
  layerIcon: messageSignIcon,
  showOnMap: true,
  defaultEnabled: true,
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Message Sign',
  markerDef: ImageDmsMarker,
  popupDef: MessageSignCard,
  cardDef: MessageSignCard,
  isPopupDialog: false,
  isMobilePopupDialog: true,
  isOnSideBar: true,
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'cms',
  updateDelay: 30,
  publishLayer: 'pcms',
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Message Signs',
  name: 'pcms',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
